import * as React from 'react';

const CircularTickIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='80'
		height='80'
		fill='none'
		viewBox='0 0 80 80'>
		<circle
			cx='36.842'
			cy='47.368'
			r='29.474'
			fill='#B5D5EA'></circle>
		<path
			stroke='#0973BA'
			strokeLinecap='round'
			strokeLinejoin='round'
			strokeWidth='3.246'
			d='M65.5 15.5 31.482 57.22a3.244 3.244 0 0 1-4.835.26L12.982 43.816'></path>
		<path
			stroke='#0973BA'
			strokeLinecap='round'
			strokeLinejoin='round'
			strokeWidth='3.246'
			d='M59.297 40.538a29.21 29.21 0 1 1-15.481-19.473'></path>
	</svg>
);

export default CircularTickIcon;
